import React, { useEffect, useState } from 'react'
import ToothTopBack from './toothTopBack'
import './teethcharts.scss'
import TeethRoots from './TeethRoots'
import ToothTopFront from './ToothTopFront'
import implantScrew from '../../../../../assets/icons/implantsvg.svg'
import { MissingToothSvg } from '../../../../../assets/icons'

function TeethContainer({ tooth, rotate, className, onClick, onhandleClick, viewWidth, rowToothNumbers }: { tooth: any, rotate: boolean, className?: string, onClick?: (e: any) => void, onhandleClick?: (e: any) => void, viewWidth?: number, rowToothNumbers?: number[] }) {

  // Use rootDiagnoses from tooth prop if available, otherwise use default
  const rootDiagnoses = tooth?.rootDiagnoses || {
    forceRedColor: false,
    hideRoot: false,
    useImplantSVG: false,
    rotate35: false,
    rotateRight35: false,
    individualRootVariants: [],
  };
  const [bridgeWidth, setbridgeWidth] = useState<React.CSSProperties>({
    width: "0px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#06b6d4",
    marginBottom: "10px",
  })
  useEffect(() => {
    
    if (!tooth.bridge || !viewWidth) {
      setbridgeWidth({ width: "0px", left: "50%", transform: "translateX(-50%)" });
      return;
    }
    const color =  tooth.bridge.bridgeType === "conventional-fixed" ? "#06b6d4" : tooth.bridge.bridgeType === "resin-bonded" ? "#ef4444" : "#a855f7";
    const marginbottom = 0;
    const bridge = tooth.bridge;
    const hasLeft = bridge.lefttooth != null && bridge.lefttooth !== undefined;
    const hasRight = bridge.righttooth != null && bridge.righttooth !== undefined;

    if (!rowToothNumbers || rowToothNumbers.length === 0) {
      const x = viewWidth / 16;
      if (hasLeft && !hasRight) {
        setbridgeWidth({ width: `${x}px`, right: "50%", backgroundColor: color, marginBottom: marginbottom });
      } else if (hasRight && !hasLeft) {
        setbridgeWidth({ width: `${x}px`, left: "50%", backgroundColor: color, marginBottom: marginbottom });
      } else if (hasLeft && hasRight) {
        setbridgeWidth({ width: `${viewWidth / 8}px`, left: "50%", transform: "translateX(-50%)", backgroundColor: color, marginBottom: marginbottom });
      } else {
        setbridgeWidth({ width: "0px", left: "50%", transform: "translateX(-50%)", backgroundColor: color, marginBottom: marginbottom });
      }
      return;
    }

    const currentIdx = rowToothNumbers.indexOf(tooth.toothNo);
    const leftIdx = hasLeft ? rowToothNumbers.indexOf(bridge.lefttooth) : -1;
    const rightIdx = hasRight ? rowToothNumbers.indexOf(bridge.righttooth) : -1;
    const x = (viewWidth+70) / rowToothNumbers.length;

    if (currentIdx === -1) {
      setbridgeWidth({ width: "0px", left: "50%", transform: "translateX(-50%)", backgroundColor: color, marginBottom: marginbottom });
      return;
    }

    const leftSpan = leftIdx >= 0 ? currentIdx - leftIdx : 0;
    const rightSpan = rightIdx >= 0 ? rightIdx - currentIdx : 0;
    const totalSpan = leftSpan + rightSpan;

    if (totalSpan === 0) {
      setbridgeWidth({ width: "0px", left: "50%", transform: "translateX(-50%)", backgroundColor: color });
      return;
    }

    const widthPx = (totalSpan) * x;
    const leftOffsetPx = (leftSpan) * x;

    if (hasLeft && hasRight) {
      setbridgeWidth({
        width: `${widthPx}px`,
        left: `calc(50% - ${leftOffsetPx}px)`,
        backgroundColor: color,
        marginBottom: marginbottom,
      });
    } else if (hasLeft) {
      setbridgeWidth({
        width: `${leftSpan * x}px`,
        right: "50%",
        backgroundColor: color,
        marginBottom: marginbottom,
      });
    } else if (hasRight) {
      setbridgeWidth({
        width: `${rightSpan * x}px`,
        left: "50%",
        backgroundColor: color,
        marginBottom: marginbottom,
      });
    } else {
      setbridgeWidth({ width: "0px", left: "50%", transform: "translateX(-50%)", backgroundColor: color, marginBottom: marginbottom });
    }
  }, [tooth.toothNo, tooth, viewWidth, rowToothNumbers])

  // Check if condition is "missing" from tooth prop
  const isMissing = tooth?.condition === "missing";

  const getBridgeTypeLabel = (bridgeType: string) => {
    if (bridgeType === "conventional-fixed") return "Conventional Fixed";
    if (bridgeType === "resin-bonded") return "Resin Bonded";
    if (bridgeType === "cantilever") return "Cantilever";
    return bridgeType;
  };

  const hasVisibleBridge = tooth?.bridge && bridgeWidth.width !== "0px";
  const bridgeTypeLabel = tooth?.bridge?.bridgeType ? getBridgeTypeLabel(tooth.bridge.bridgeType) : "";

  const handleClick = (e: any) => {

    onhandleClick?.(e);
  };

  return (
    <div className={`tooth-modal-bodies relative ${rotate ? 'column-reverse' : ''} ${className}`} onClick={onClick}>

      <span className='text-xl font-bold text-center text-slate-800 color-primary'>{tooth.toothNo}</span>
      {rootDiagnoses?.useImplantSVG
        ? <img src={implantScrew} alt="implantScrew" className={`w-12 h-12 ${rotate ? '' : 'rotate-180'}`} />
        : <TeethRoots rotate={rotate} root={tooth?.root} rootDiagnoses={rootDiagnoses} />}
      {isMissing
        ? <MissingToothSvg tooth={tooth} handleClick={handleClick} />
        : tooth.front
          ? <ToothTopFront surface={tooth.surface} tooth={tooth} handleClick={handleClick} />
          : <ToothTopBack surface={tooth.surface} tooth={tooth} handleClick={handleClick} />
      }
      {hasVisibleBridge && (
        <>
          <span
            className="absolute left-1/2 -translate-x-1/2 text-[10px] font-medium whitespace-nowrap pointer-events-none z-[50]"
            style={{
              color: bridgeWidth.backgroundColor ?? "#06b6d4",
              ...(rotate === true ? { top: "24px" } : { bottom: "24px" }),
            }}
          >
            {bridgeTypeLabel}
          </span>
          <span
            aria-label={`Bridge line, tooth ${tooth.toothNo}`}
            data-name="bridge-line"
            role="presentation"
            style={{
              color: "white",
              borderRadius: "10px",
              height: "4px",
              position: "absolute",
              ...(rotate === true ? { top: "20px" } : { bottom: "20px" }),
              zIndex: 100,
              ...bridgeWidth
            }}
          />
        </>
      )}
    </div>
  )
}

export default TeethContainer